import {
  ResponsiveContainer,
  AreaChart,
  Area,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
} from "recharts";
import type { GrowthPoint } from "../../types/analytics";
import styles from "./GrowthChart.module.css";

interface GrowthChartProps {
  data: GrowthPoint[];
}

function formatDate(dateStr: string): string {
  const d = new Date(dateStr + "T00:00:00");
  return d.toLocaleDateString(undefined, { month: "short", day: "numeric" });
}

export function GrowthChart({ data }: GrowthChartProps) {
  if (data.length === 0) {
    return <div className={styles.empty}>No data for selected period</div>;
  }

  const formatted = data.map((p) => ({ ...p, label: formatDate(p.date) }));

  return (
    <div className={styles.container}>
      <h3 className={styles.title}>Downloads &amp; Streams</h3>
      <ResponsiveContainer width="100%" height={300}>
        <AreaChart data={formatted} margin={{ top: 5, right: 20, bottom: 5, left: 0 }}>
          <defs>
            <linearGradient id="gradDownloads" x1="0" y1="0" x2="0" y2="1">
              <stop offset="0%" stopColor="#6366f1" stopOpacity={0.3} />
              <stop offset="100%" stopColor="#6366f1" stopOpacity={0} />
            </linearGradient>
            <linearGradient id="gradStreams" x1="0" y1="0" x2="0" y2="1">
              <stop offset="0%" stopColor="#06b6d4" stopOpacity={0.3} />
              <stop offset="100%" stopColor="#06b6d4" stopOpacity={0} />
            </linearGradient>
          </defs>
          <CartesianGrid strokeDasharray="3 3" stroke="#e5e7eb" />
          <XAxis dataKey="label" tick={{ fontSize: 12 }} />
          <YAxis tick={{ fontSize: 12 }} />
          <Tooltip />
          <Legend />
          <Area
            type="monotone"
            dataKey="downloads"
            stroke="#6366f1"
            fill="url(#gradDownloads)"
            strokeWidth={2}
          />
          <Area
            type="monotone"
            dataKey="streams"
            stroke="#06b6d4"
            fill="url(#gradStreams)"
            strokeWidth={2}
          />
        </AreaChart>
      </ResponsiveContainer>
    </div>
  );
}
